<template>
  <v-container class="pa-0" fluid>
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-2">
          <h3>{{ getTitle }}</h3></v-card-title
        >
        <v-card-text>
          <el-overlay-loading dashboard :loading="pageloading" />
          <v-row class="pt-1 pb-3">
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="kinds"
                direct
                multiple
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Objektas"
                v-model="formData.kind"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                @change="updateBoard()"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Data"
                v-model="formData.date"
              />
            </v-col>
            <v-col>
              <!-- <export-btn :object="type" :id="chartId"></export-btn> -->
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="pt-1 pb-3">
            <v-col cols="12">
              <Pie
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { Pie } from 'vue-chartjs/legacy'
import moment from 'moment'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'PieChartForm',
  props: {
    type: [String],
  },
  components: {
    Pie,
  },
  data() {
    return {
      pageloading: false,
      //
      formData: {},
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            intersect: true,
            callbacks: {
              label: (context) => {
                const label = context.label || ''
                const value = context.parsed || 0
                const dataset = context.dataset || {}

                if (dataset.data) {
                  const total = dataset.data.reduce(
                    (accumulator, currentValue) =>
                      accumulator + Number(currentValue),
                    0
                  )
                  if (total > 0) {
                    const percentage = ((value / total) * 100).toFixed(2)
                    return `${label}: ${value} (${percentage}%)`
                  }
                }

                return `${label}: ${value}`
              },
            },
          },
          legend: {
            display: true,
            labels: {
              generateLabels: function (chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  const dataset = data.datasets[0]
                  return data.labels.map(function (label, index) {
                    let backgroundColor = dataset.backgroundColor[index]
                    let value = dataset.data[index]
                    let total = dataset.data.reduce(
                      (accumulator, currentValue) =>
                        accumulator + Number(currentValue),
                      0
                    )
                    let percentage = ((value / total) * 100).toFixed(2)
                    let text = ``
                    if (value) {
                      text = `${label} - ${value} (${percentage}%)`
                    } else {
                      text = label
                    }
                    return {
                      text: text,
                      fillStyle: backgroundColor,
                      hidden: false,
                    }
                  })
                }
                return []
              },
            },
          },
        },
      },
      //
      chartId: `${this.type}_pie_chart`,
      datasetIdKey: 'label',
      width: 400,
      height: 200,
      cssClasses: '',
      styles: {},
      plugins: [],
      colors: [
        'rgba(0, 76, 76, 1)',
        'rgba(255, 153, 102, 1)',
        'rgba(178, 216, 216, 1)',
        'rgba(255, 204, 92, 1)',
        'rgba(19, 122, 127, 1)',
        'rgba(153, 153, 153, 1)',
        'rgba(255, 82, 82, 1)',
        'rgba(0, 80, 115, 1)',
        'rgba(255, 186, 186, 1)',
        'rgba(17, 17, 17, 1)',
      ],
    }
  },
  computed: {
    kinds() {
      return [
        {
          text: 'ITPSĮ',
          value: 'itpsi',
        },
        {
          text: 'NTPĮ',
          value: 'ntpi',
        },
        {
          text: 'Prokūra',
          value: 'prokura',
        },
      ]
    },
    getTitle() {
      switch (this.type) {
        case 'registered':
          return this.$t('Įregistruoti objektai')
        case 'deregistered':
          return this.$t('Išregistruoti objektai')
        default:
          return this.$t('Visi objektai')
      }
    },
    getUrl() {
      switch (this.type) {
        case 'registered':
          return `dashboard/registeredObjects`
        case 'deregistered':
          return `dashboard/deregisteredObjects`
        default:
          return `dashboard/allObjects`
      }
    },
  },
  created() {
    this.$set(this.formData, 'date', moment().format('YYYY-MM-DD'))
    this.$set(this.formData, 'kind', ['itpsi', 'ntpi', 'prokura'])
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true

      this.$axios
        .post(this.getUrl, this.formData)
        .then((res) => {
          let backgroundArr = []
          for (let index = 0; index < res.data.labels.length; index++) {
            backgroundArr.push(this.colors[index])
          }
          this.chartData = {
            labels: res.data.labels,
            datasets: [
              {
                backgroundColor: backgroundArr,
                data: res.data.data,
              },
            ],
          }
          this.pageloading = false
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
        })
    },
    updateBoard() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped></style>
